// ** IMPORTANT **: Keep in sync with functions/src/index.ts
export enum BOOK_INVITE_SOURCE_TYPE {
    webBookPurchase = 'web-book-purchase',
    digitalBookPurchase = 'digital-book-purchase',
    physicalBookPurchase = 'physical-book-purchase',
    manualAdjustment = 'manual-adjustment',
}
